module.exports = __webpack_public_path__ + "bj.svg?5561ec954d9c2ec533400b805354a4b6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bj.svg
// module id = 1258
// module chunks = 0